'use strict';
const angular = require('angular');

/*@ngInject*/
export function PaymentService($resource) {
  return $resource('/api/payments/:id', {
    id: '@_id'
  },{
    stripePayment: {
      method: 'POST',
      url: "/api/payments/cc/:userId"
    },
    stripePaymentACH: {
      method: 'POST',
      url: "/api/payments/ach/:userId"
    }
  });
}

export default angular.module('conduuApp.PaymentService', [])
  .factory('PaymentService', PaymentService)
  .name;



// WEBPACK FOOTER //
// ./client/services/payment/payment.service.js